import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";
import {ShopeeService} from "../../services/shopee.service";
import {DeviceService} from "../../services/device.service";
import {OwlOptions} from "ngx-owl-carousel-o";
import {environment} from "../../../environments/environment";

const PLACEHOLDER_COUNT = 6;

@Component({
  selector: 'list-shopee-hot',
  templateUrl: './list-shopee-hot.component.html',
  styleUrls: ['./list-shopee-hot.component.css']
})
export class ListShopeeHotComponent implements OnInit {
  listShopee: any = [];
  // owl-carousel-o measures 0 width when server-rendered, so it ships slides with no item width
  // that render stacked vertically on mobile. Gating the carousel on isBrowser (and on `loaded`,
  // so it initializes once with the final slide set instead of the placeholder→data swap) lets
  // owl measure the real container width in the browser and lay the slides out horizontally.
  isBrowser: boolean;
  loaded = false;
  apiUrl = environment.apiUrl;
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ['', ''],
    margin: 8,
    responsive: {
      0: {
        items: 3
      },
      400: {
        items: 3
      },
      740: {
        items: 3
      },
      940: {
        items: 3
      }
    },
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
  }

  constructor(
    private shopeeService: ShopeeService,
    private deviceService: DeviceService,
    @Inject(PLATFORM_ID) platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  async ngOnInit() {
    this.listShopee = Array(PLACEHOLDER_COUNT).fill({
      is_lazy: true,
      name: "loading...",
      image: "assets/images/default_image.png",
      link: "",
    });
    await this.shopeeService.searchList({limit: 12}).then((res) => {
      if (res?.status) {
        this.listShopee = res.data;
      } else {
        this.listShopee = [];
      }
    });
    this.loaded = true;
  }

  isMobile() {
    return this.deviceService.isMobile();
  }

  handleClick(slide: any) {
    console.log(slide);
  }
}
